(() => {
  'use strict';
  const init = (section) => {
    if (section.dataset.gelReady) return;
    const form = section.querySelector('[data-gel-form]');
    const dataNode = section.querySelector('[data-gel-data]');
    if (!form || !dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
    if (!Array.isArray(data.variants)) return;
    section.dataset.gelReady = 'true';
    const inputs = [...section.querySelectorAll('input[name="id"]')];
    const buttons = [...section.querySelectorAll('[data-gel-buy]')];
    const offers = [...section.querySelectorAll('[data-gel-offer]')];

    const hero = section.querySelector('[data-gel-hero]');
    const hand = section.querySelector('[data-gel-hand]');
    const imageWrap = section.querySelector('[data-gel-image-wrap]');
    const error = section.querySelector('[data-gel-error]');
    const recovery = section.querySelector('[data-gel-recovery]');
    const sticky = section.querySelector('[data-gel-sticky]');
    const slots = [...section.querySelectorAll('[data-gel-slot]')];
    const shadePicker = section.querySelector('.tl-gel__shades');
    const lightbox = section.querySelector('[data-gel-lightbox]');
    const motion = section.querySelector('[data-gel-motion]');
    const refills = Array.isArray(data.refills) ? data.refills : [];
    const selections = [data.variants.find(v => String(v.id) === inputs.find(i => i.checked)?.value), null];
    const refillFor = (v) => v && refills.find(r => r.title === v.title);
    const duoReady = data.duoEnabled === true && refills.length > 0;
    let isDuo = false;
    let activeSlot = 0;
    let pending = false;
    let uncertain = false;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:data.currency || 'USD'}).format(cents / 100) + ` ${data.currency || 'USD'}`;
    const text = (selector, value) => section.querySelectorAll(selector).forEach(el => { el.textContent = value; });
    const priceOfExtra = () => {
      const r = refillFor(selections[1]);
      if (r) return r.cents;
      if (refills.length) return Math.min(...refills.map(v => v.cents));
      return data.preview && data.currency === 'USD' ? 1250 : null;
    };
    const purchasable = () => !!selections[0]?.available && (!isDuo || (duoReady && refillFor(selections[1])?.available));
    const paintImage = () => {
      const v = selections[0];
      if (hero && v?.image) {
        hero.removeAttribute('srcset'); hero.src = v.image;
        hero.alt = v.title + ' starter kit: 16 strips, white lamp, mini file and wooden stick';
      }
      if (hand && v?.hand) { hand.src = v.hand; hand.alt = v.title + ' on natural nails'; }
      imageWrap?.classList.toggle('is-split', !!v?.hand);
      section.querySelector('[data-gel-hand-wrap]').hidden = !v?.hand;
      section.querySelectorAll('[data-gel-photo]').forEach(link => {
        const isHand = link.dataset.gelPhoto === 'hand';
        link.href = (isHand ? v?.hand : v?.image) || '';
        link.setAttribute('aria-label', 'Enlarge ' + v?.title + (isHand ? ' manicure photograph' : ' kit photograph'));
      });
    };
    const paint = (updateUrl = false) => {
      const first = selections[0];
      const extra = priceOfExtra();
      const discountedExtra = extra === null ? null : extra - Math.round(extra * .60);
      const duoPrice = first && discountedExtra !== null ? money(first.cents + discountedExtra) : 'Price at checkout';
      text('[data-gel-shade]', isDuo ? [first?.title, selections[1]?.title || 'Choose design 2'].join(' + ') : first?.title || 'Choose a shade');
      text('[data-gel-price]', isDuo ? duoPrice : first?.price || '');
      text('[data-gel-starter-price]', first?.price || '');
      text('[data-gel-duo-price]', duoPrice);
      // This compares today's purchasable components, not a fabricated former kit price.
      const hasComparison = duoReady && first && extra !== null && discountedExtra < extra;
      text('[data-gel-separate-price]', hasComparison ? money(first.cents + extra) : '');
      section.querySelectorAll('[data-gel-main-comparison]').forEach(el => { el.hidden = !isDuo || !hasComparison; });
      section.querySelectorAll('[data-gel-duo-comparison]').forEach(el => { el.hidden = !hasComparison; });
      text('[data-gel-saving]', extra === null ? '' : `Save ${money(extra - discountedExtra)} on your extra design`);
      text('[data-gel-summary]', isDuo ? '2 designs + 1 lamp + tools' : '1 design + lamp + tools');
      text('[data-gel-first-name]', selections[activeSlot]?.title || 'Choose design 2');
      text('[data-gel-bundle-status]', isDuo ? (selections[1] ? '2 of 2 designs selected.' : 'Choose your second design.') + (!duoReady ? ' Color Duo is currently unavailable.' : ' Extra-design discount applied at checkout.') : '16 strips in your chosen design. Lamp and tools included.');
      buttons.forEach(button => { button.disabled = pending || uncertain || !first?.available || (isDuo && (!duoReady || (selections[1] && !refillFor(selections[1])?.available))); });
      text('[data-gel-button-label]', pending ? 'Opening checkout...' : uncertain ? 'Check your cart' : isDuo && !selections[1] ? 'Choose design 2' : isDuo && !duoReady ? 'Duo unavailable' : purchasable() ? data.label : 'Sold out');
      offers.forEach(input => { input.disabled = pending || uncertain; input.checked = (input.value === 'duo') === isDuo; });
      section.querySelector('[data-gel-slots]').hidden = !isDuo;
      text('[data-gel-selection-help]', selections[1] ? (first.id === selections[1].id ? '2 sets of the same design selected.' : 'Both designs selected. Tap 1 or 2 to change either.') : 'Choose design 2 below. You can choose the same design twice.');
      slots.forEach(slot => {
        const index = Number(slot.dataset.gelSlot), v = selections[index];
        slot.disabled = pending || uncertain;
        slot.setAttribute('aria-pressed', String(activeSlot === index));
        slot.querySelector('[data-gel-slot-name]').textContent = v?.title || 'Choose a design';
        const img = slot.querySelector('img');
        img.hidden = !v;
        if (v) img.src = v.hand || refillFor(v)?.image || v.image;
      });
      section.querySelectorAll('[data-gel-sticky-image]').forEach(img => {
        const index = Number(img.dataset.gelStickyImage), v = selections[index];
        img.hidden = !v || (index === 1 && !isDuo);
        if (v) { img.src = v.hand || refillFor(v)?.image || v.image; img.alt = v.title; }
      });
      section.querySelectorAll('[data-gel-offer-image]').forEach(img => {
        const index = Number(img.dataset.gelOfferImage);
        const v = selections[index] || first;
        if (v) img.src = v.hand || (index ? refillFor(v)?.image || v.image : v.image);
      });
      const status = section.querySelector('[data-gel-bundle-status]');
      status.hidden = !isDuo || duoReady;
      inputs.forEach(input => {
        const v = data.variants.find(v => String(v.id) === input.value);
        input.checked = String(selections[activeSlot]?.id) === input.value;
        const available = activeSlot === 1 ? refillFor(v)?.available : v?.available;
        input.disabled = pending || uncertain || !available;
        const choice = input.closest('[data-gel-choice]');
        const isFirst = String(first?.id) === input.value;
        const isSecond = isDuo && String(selections[1]?.id) === input.value;
        choice.classList.toggle('is-first', isFirst);
        choice.classList.toggle('is-second', isSecond);
        const badge = choice.querySelector('[data-gel-count]');
        badge.hidden = !isFirst && !isSecond;
        badge.textContent = isFirst && isSecond ? '2 sets' : isFirst ? '1' : '2';
        input.setAttribute('aria-label', v.title + (isFirst && isSecond ? ', 2 sets selected' : isFirst ? ', first design' : isSecond ? ', second design' : '') + (!available ? ', sold out' : ''));
        const availability = choice.querySelector('[data-gel-availability]');
        if (availability) availability.hidden = !!available;
      });
      paintImage();
      if (updateUrl && first) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', first.id);
        window.history.replaceState({}, '', url);
      }
    };
    const bundle = section.querySelector('[data-gel-bundle]');
    if (bundle) bundle.hidden = !duoReady && !data.preview;
    const closeDialog = dialog => dialog?.close();
    const openDialog = dialog => {
      if (!dialog || dialog.open) return;
      dialog.showModal();
    };
    const chooseSlot = (index, scroll = false) => {
      if (pending || uncertain || (index === 1 && !isDuo)) return;
      activeSlot = index; paint();
      if (scroll) {
        shadePicker.scrollIntoView({block:'start',behavior:'auto'});
        slots[index]?.focus({preventScroll:true});
      }
    };
    offers.forEach(input => input.addEventListener('change', () => {
      if (pending || uncertain) return;
      isDuo = input.value === 'duo'; activeSlot = 0; error.hidden = true; paint();
      if (isDuo && !selections[1]) chooseSlot(1, true);
    }));
    slots.forEach(slot => slot.addEventListener('click', () => chooseSlot(Number(slot.dataset.gelSlot))));
    section.querySelector('[data-gel-close]')?.addEventListener('click', () => closeDialog(lightbox));
    section.querySelectorAll('[data-gel-photo]').forEach(link => link.addEventListener('click', event => {
      if (!lightbox?.showModal) return;
      event.preventDefault();
      const source = link.querySelector('img');
      const full = section.querySelector('[data-gel-lightbox-image]');
      full.src = link.href; full.alt = source.alt;
      text('[data-gel-lightbox-caption]', source.alt);
      openDialog(lightbox);
    }));
    [lightbox].forEach(dialog => {
      dialog?.addEventListener('click', event => {
        if(event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
      });
    });
    // Load the reference clip only near the viewport; respect motion and data preferences.
    if (motion) {
      let visible = false, manualPause = false, programmaticPause = false;
      const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      const canAutoPlay = () => !reduced?.matches && !window.navigator?.connection?.saveData;
      const loadMotion = () => {
        const source = motion.querySelector('source');
        if (!source.src) { source.src = source.dataset.src; motion.load(); }
      };
      motion.addEventListener('pause', () => { if (!programmaticPause && visible) manualPause = true; });
      const stopMotion = () => {
        programmaticPause = true; motion.pause();
        setTimeout(() => { programmaticPause = false; },0);
      };
      const syncMotion = () => {
        if (visible) loadMotion();
        if (visible && canAutoPlay() && !manualPause && !document.hidden) motion.play()?.catch(() => {});
        else stopMotion();
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; syncMotion(); },{rootMargin:'100px'});
        observer.observe(motion); section._gelMotionObserver = observer;
      } else { loadMotion(); }
      reduced?.addEventListener?.('change', syncMotion);
      document.addEventListener('visibilitychange', syncMotion);
      section._gelCleanup = () => { document.removeEventListener('visibilitychange',syncMotion); reduced?.removeEventListener?.('change',syncMotion); stopMotion(); };
    }
    const selectDesign = input => {
      if (pending || uncertain || input.disabled) return;
      selections[activeSlot] = data.variants.find(v => String(v.id) === input.value);
      error.hidden = true;
      paint(activeSlot === 0);
    };
    inputs.forEach(input => {
      // Click also fires for an already-checked radio: needed for two of the same design.
      input.addEventListener('click', () => selectDesign(input));
      input.addEventListener('change', () => selectDesign(input));
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || uncertain) return;
      if (isDuo && !selections[1]) { chooseSlot(1, true); return; }
      if (!purchasable()) return;
      pending = true;
      error.hidden = true;
      recovery.hidden = true;
      form.setAttribute('aria-busy','true');
      paint();
      const items = [{id:selections[0].id,quantity:1}];
      // The native starter expands into lamp + strips; the extra line adds strips only.
      if(isDuo) items.push({id:refillFor(selections[1]).id,quantity:1});
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(),20000);
      try {
        const response = await fetch(`${form.action.replace(/\/$/,'')}.js`, {
          method:'POST',credentials:'same-origin',signal:controller.signal,
          headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok) {
          // A multi-item error can follow a partial add. Never encourage a blind retry.
          if(response.status >= 500 || isDuo) uncertain = true;
          throw new Error(result.description || result.message || 'This kit could not be added. Please try another shade.');
        }
        uncertain = true;
        window.location.assign(data.cartUrl.replace(/\/cart\/?$/,'/checkout'));
      } catch(failure) {
        if(failure.name === 'AbortError' || failure instanceof TypeError || failure instanceof SyntaxError) uncertain = true;
        error.textContent = uncertain ? 'We could not confirm the complete cart response. Please check your cart before adding again so you do not get a duplicate kit.' : failure.message;
        error.hidden = false;
        recovery.hidden = !uncertain;
        error.focus({preventScroll:true});
        error.scrollIntoView({block:'center',behavior:'auto'});
      } finally {
        clearTimeout(timer);
        pending = false;
        form.removeAttribute('aria-busy');
        paint();
      }
    });
    if('IntersectionObserver' in window && sticky) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0; });
      observer.observe(section.querySelector('[data-gel-main-price]') || form);
      section._gelObserver = observer;
    }
    paint();
  };
  const boot = (scope = document) => scope.querySelectorAll('[data-gel-kit]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load',event => boot(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-gel-kit]').forEach(section => { section._gelObserver?.disconnect(); section._gelMotionObserver?.disconnect(); section._gelCleanup?.(); }));
  window.addEventListener('pageshow',event => { if(event.persisted) window.location.reload(); });
})();
